import { useQuery } from '@tanstack/react-query';
import { getVideoModels } from '@utils/api/videoProjects';
import { modelForSubject } from '@config/videoDetectionModelConfig';

/**
 * The model a subject is counted with, under the name the backend gives it (GET /video-projects/models).
 * While the list loads, or when the call fails, the name is the config label.
 */
const useSubjectModel = subject => {
	const { data: models } = useQuery({
		queryKey: ['videoModels'],
		queryFn: getVideoModels,
		staleTime: Infinity,
		refetchOnWindowFocus: false,
	});
	const model = modelForSubject(subject);
	const label = models?.find(m => m.model_id === model.value)?.label;
	return label ? { ...model, label } : model;
};

export default useSubjectModel;
